import { createApp } from 'vue'
import component from "./index.vue";

const customizeTips = app => {
    app.use(component)
};
export default {
    customizeTips,
    install(app) {
        let instance = createApp(component).mount(document.createElement("div"));
        document.body.appendChild(instance.$el)
        app.config.globalProperties.$tips = instance;
    }
}